// extracted by mini-css-extract-plugin
export var cartItem = "_p-3";
export var drawerContent = "_p-0";
export var emptyCart = "_p-2";
export var fadeIn = "_p-4";
export var imagePlaceholder = "_p-6";
export var itemImage = "_p-5";
export var itemsContainer = "_p-1";